import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import {
  SwipeableDrawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';
import { navLinks } from '../../utils/navLinks';
import { socialLinks } from '../../utils/socialLinks';

const useStyles = makeStyles({
  sidebar: {
    width: '250px',
    background: 'black',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  sidebarTitle: {
    height: '60px',
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '36px',
    background: '#4ceb95',
    fontWeight: 'bolder',
    fontSize: '20px',
  },
  sidebarLinks: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '8px 0px 8px 16px',
    alignItems: 'center',
  },
  icons: {
    fontSize: '22px',
  },
  socials: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  social: {
    display: 'flex',
  },
  socialLink: {
    padding: '0px 15px',
  },
});

const Sidebar = ({ sidebar, setSidebar, handleSidebar }) => {
  const classes = useStyles();

  const SidebarItems = () => {
    return (
      <div className={classes.sidebar}>
        <div className={classes.sidebarTitle}>Ken White</div>
        <List>
          {navLinks.map((link) => {
            const { id, url, label, icon } = link;
            return (
              <Link
                className={classes.sidebarLinks}
                onClick={handleSidebar}
                key={id}
                to={url}
              >
                <ListItem>
                  <ListItemIcon
                    className={classes.icons}
                    style={{ color: '#4ceb95' }}
                  >
                    {icon}
                  </ListItemIcon>
                  <ListItemText>{label}</ListItemText>
                </ListItem>
              </Link>
            );
          })}
        </List>

        <Divider />

        <div className={classes.socials}>
          <List className={classes.social}>
            {socialLinks.map((link) => {
              const { id, url, icon } = link;
              return (
                <Link
                  className={classes.socialLink}
                  onClick={handleSidebar}
                  key={id}
                  to={url}
                >
                  <ListItem style={{ width: '14px', padding: 0 }}>
                    <ListItemIcon
                      className={classes.icons}
                      style={{ color: '#4ceb95' }}
                    >
                      {icon}
                    </ListItemIcon>
                  </ListItem>
                </Link>
              );
            })}
          </List>
        </div>
      </div>
    );
  };

  return (
    <>
      <SwipeableDrawer
        anchor="left"
        open={sidebar}
        onOpen={() => setSidebar(true)}
        onClose={() => setSidebar(false)}
      >
        <SidebarItems />
      </SwipeableDrawer>
    </>
  );
};

export default Sidebar;
